// One-click download of MFA recovery codes to the user's computer as a .txt file.
// Plain text (not PDF) — no extra rendering dependency needed, opens everywhere, and is
// still trivially printable if the user wants a hard copy.
export function downloadRecoveryCodes(codes, { email = '' } = {}) {
  if (!Array.isArray(codes) || codes.length === 0) return;

  const lines = [
    'Pipsqueak — Two-Factor Authentication Recovery Codes',
    email ? `Account: ${email}` : null,
    `Generated: ${new Date().toLocaleString()}`,
    '',
    'Each code below can be used ONCE to sign in if you lose access to your authenticator app.',
    'Store this file somewhere safe (a password manager is ideal). Anyone with a code can use it to sign in.',
    '',
    ...codes,
    ''
  ].filter(line => line !== null);

  const blob = new Blob([lines.join('\n')], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'pipsqueak-recovery-codes.txt';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
